module.exports = __webpack_public_path__ + "img/eagle.c2a8733b.svg";